import React from 'react';
import SidebarUnitDesktop
    from "components/sidebar/components/SidebarUnitDesktop";
import {Calendar} from "assets/icons";

const TimeSheetLink = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Relevés d'heures"} 
            routeSidebar={"/timeSheet/toBeChecked"}
            icon={Calendar}
            text={"Relevés d'heures"}
        />
    );
};

export default TimeSheetLink;